import "./index.scss";

import { getPhoto } from "api/admin/adminApi";
import { Avatar } from "appkit-react";
import classNames from "classnames";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { getInitialsFromName } from "../../utils/index";

const AvatarWithAsyncPhoto = ({ photoUri, name, className = "", children = null, ...props }) => {
  const elRef = useRef();
  const [photo, setPhoto] = useState(undefined);

  const updatePhoto = useCallback((src) => {
    if (src === undefined || !elRef.current) return;
    setPhoto(src);
  }, []);

  useEffect(() => {
    if (photoUri) {
      getPhoto(photoUri).then(updatePhoto);
    } else {
      updatePhoto(undefined);
    }
  }, [photoUri, updatePhoto]);

  const initials = useMemo(() => {
    if (!name) {
      return " ";
    }
    return getInitialsFromName(name);
  }, [name]);

  return (
    <Avatar {...props} ref={elRef} className={classNames("a-avatar-async-photo", className)}>
      {photo ? <img src={photo} alt={initials} /> : initials}
      {children && <div className="a-avatar-async-photo-children">{children}</div>}
    </Avatar>
  );
};

export default AvatarWithAsyncPhoto;
